export const MANDATORY_DATA_FIELDS_TO_DISPLAY = [
  'imageUrl',
  'title',
  'description',
  'sku',
  'price',
  'originalPrice',
];
